export const REQUEST_BACKSTOPDATE = 'REQUEST_BACKSTOPDATE';
export const RECEIVE_BACKSTOPDATE = 'RECEIVE_BACKSTOPDATE';
export const SET_BACKSTOPDATE_FAILURE = 'SET_BACKSTOPDATE_FAILURE';
export const CLEAR_BACKSTOPDATE_ERROR_MESSAGE = 'CLEAR_BACKSTOPDATE_ERROR_MESSAGE';
